import { axiosInstance as axios } from '../../axios/axios';
import * as Action from '../actions/index';
import { getErrorMsg } from '../../utils/customizeError';

export const addProduct = (data, setLoading, token) => {
  return async (dispatch) => {
    try {
      setLoading(true);
      const fd = new FormData();
      fd.append('title', data.title);
      fd.append('price', data.price);
      fd.append('description', data.description);
      fd.append('category', 1);
      fd.append('image', data.image);
      await axios.post('api/dashboard/products', fd, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      });

      setLoading(false);
      dispatch({
        type: Action.CREATE_ERROR,
        payload: { msg: 'Product Added', type: 'success' },
      });
    } catch (err) {
      const msg = getErrorMsg(err);
      dispatch({
        type: Action.CREATE_ERROR,
        payload: { msg, type: 'error' },
      });
      setLoading(false);
    }
  };
};
export const editProduct = (data, setLoading, token) => {
  return async (dispatch) => {
    try {
      setLoading(true);
      await axios.patch('api/dashboard/products/:id', data, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      });

      setLoading(false);
      dispatch({
        type: Action.CREATE_ERROR,
        payload: { msg: 'Edit Successful', type: 'success' },
      });
    } catch (err) {
      const msg = getErrorMsg(err);
      dispatch({
        type: Action.CREATE_ERROR,
        payload: { msg, type: 'error' },
      });
      setLoading(false);
    }
  };
};
export const deleteProduct = (id, setLoading) => {
  return async (dispatch) => {
    try {
      setLoading(true);

      await axios.delete(`api/dashboard/products/${id}`);
      dispatch({
        type: Action.DELETE_PRODUCT,
        payload: id,
      });
      dispatch({
        type: Action.CREATE_ERROR,
        payload: { msg: 'Product deleted ', type: 'success' },
      });
    } catch (err) {
      const msg = getErrorMsg(err);
      dispatch({
        type: Action.CREATE_ERROR,
        payload: { msg, type: 'error' },
      });
      setLoading(false);
    }
  };
};

export const getMenuCategories = () => {
  return async (dispatch) => {
    try {
      const categories = await axios.get('/api/home/categories?limit=3');

      dispatch({
        type: 'ADD_MENU_CATEGORIES',
        payload: { categories: categories.data.data },
      });
    } catch (err) {
      const msg = getErrorMsg(err);
      dispatch({
        type: 'ADD_MENU_CATEGORIES',
        payload: { categories: [] },
      });
      dispatch({
        type: Action.CREATE_ERROR,
        payload: { msg, type: 'error' },
      });
    }
  };
};

export const getAllProducts = () => {
  return async (dispatch) => {
    try {
      const res = await axios.get('/api/home/products?limit=15');
      dispatch({ type: Action.ADD_MENU_PRODUCTS, payload: res.data.data });
    } catch (err) {
      const msg = getErrorMsg(err);
      dispatch({ type: Action.ADD_MENU_PRODUCTS, payload: [] });

      dispatch({
        type: Action.CREATE_ERROR,
        payload: { msg, type: 'error' },
      });
    }
  };
};
